import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import styled from 'styled-components';
import { GET_USER_ROLES } from '../graphql/queries';
import Loader from './Loader';
import RoleInvite from './RoleInvite';
import Organization from './Organization';

const LoaderContainer = styled.div`
min-height:100vh;
max-height:100vh;
display: flex;
justify-content: center;
align-items: center;
`;

export default function Onboarding() {
  const [hasInvites, setHasInvites] = useState(false);
  const { data, loading, error } = useQuery(GET_USER_ROLES);

  useEffect(() => {
    if (data && data.getUserRoles) {
      setHasInvites(data.getUserRoles.find((r) => !r.acceptedAt));
    }
  }, [data]);

  if (loading && !data && !error) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  const pendingRoles = data?.getUserRoles?.filter(
    (r) => !r.acceptedAt || r.acceptedAt === 0,
  );

  return hasInvites ? <RoleInvite roles={pendingRoles} /> : <Organization />;
}
